import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import HvButton from "./HvButton";
import Reveal from "./Reveal";

const Newsletter = () => {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
  };

  return (
    <section className="hv2-newsletter" id="newsletter">
      <div className="home-v2__container">
        <Reveal as="div" className="hv2-newsletter__box">
          <div className="hv2-newsletter__content">
            <span className="hv2-newsletter__label">— STAY IN THE LOOP</span>
            <h2 className="home-v2__h3">Not ready to sign up? Stay close</h2>
            <p>Leave your email and we&apos;ll let you know as soon as we have news worth sharing.</p>
          </div>
          <form className="hv2-newsletter__form" onSubmit={handleSubmit}>
            <TextField
              placeholder="First name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              InputProps={{ disableUnderline: true }}
            />
            <TextField
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{ disableUnderline: true }}
            />
            <HvButton variant="primary" type="submit">
              Subscribe
            </HvButton>
          </form>
        </Reveal>
      </div>
    </section>
  );
};

export default Newsletter;
